import { birthdayText } from './birthdayText';
import { truckAnniversaryText } from './truckAnniversaryText';
import { followUpText } from './followUpText';
import { leadLostText } from './leadLostText';

export const smsTemplates = {
  birthdayText,
  truckAnniversaryText,
  followUpText,
  leadLostText,
};

export type SmsTemplateName = keyof typeof smsTemplates;
